import React from 'react'
import PropTypes from 'prop-types'
import {Text, Stack, useMultiStyleConfig, Image, Flex, Button} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'

const ProductRegistrationProducts = ({product, variant, onClick}) => {
    const searchStyles = useMultiStyleConfig('ProductRegistrationProducts', {variant})
    const intl = useIntl()

    return (
        <Flex {...searchStyles.productDetails}>
            <Image
                {...searchStyles.productImage}
                src={product.image?.link}
                alt={product.productName}
            />
            <Stack {...searchStyles.productLabels}>
                <Text {...searchStyles.productTitle}>
                    {product?.representedProduct?.c_variantIdentifier ||
                        product?.name ||
                        product?.productName}
                </Text>
                <Text {...searchStyles.productDescription}>{product?.representedProduct?.id}</Text>
                <Button
                    onClick={onClick}
                    {...searchStyles.productButton}
                    variant={'primary'}
                    role="link"
                    aria-label={`${intl.formatMessage({
                        id: 'product_registration_page.select_button',
                        defaultMessage: 'Select',
                    })} ${
                        product?.representedProduct?.c_variantIdentifier ||
                        product?.name ||
                        product?.productName
                    }`}
                    data-testid="select-button"
                >
                    <Text {...searchStyles.buttonText}>
                        <FormattedMessage
                            id="product_registration_page.select_button"
                            defaultMessage="TEST1234"
                        />
                    </Text>
                </Button>
            </Stack>
        </Flex>
    )
}

ProductRegistrationProducts.propTypes = {
    product: PropTypes.object,
    variant: PropTypes.string,
    onClick: PropTypes.func,
}

export default ProductRegistrationProducts
